import { definePreset } from '@primeuix/themes';
// @ts-ignore
import Lara from '@primeuix/themes/lara';

export const LaraCustom = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#e7eefb',
      100: '#b3cbf3',
      200: '#8fb1ee',
      300: '#5c8ee6',
      400: '#3c78e1',
      500: '#0b56d9', // fill-primary base-blue-blue-500
      600: '#0a4ec5',
      700: '#083d9a',
      800: '#062f77', // text-primary base-blue-blue-800
      900: '#05245b',
    },
    mgreen: {
      500: '#30b052', // base-green-green-500
      700: '#227d3a', // base-green-green-700
    },
    mred: {
      50: '#fdeeec', // base-red-red-50
      100: '#f9cac4', // base-red-red-100
      300: '#f28d7f', // base-red-red-300
    },
    colorScheme: {
      light: {
        surface: {
          0: '#fcfcfc',
          50: '#e7eefb',
          100: '#eff2f3',
          200: '#ced7db', // border-primary base-blue-gray-blue-gray-100
          300: '#bac0c2', // text-disabled base-black-black-100
          400: '#99a1a4',
          500: '#6b767b', // text-placeholder base-black-black-300 6b767b f670f8
          600: '#4e5c61', // text-tertiary base-black-black-400 4e5c61 30b052
          700: '#22333a',
          800: '#1f2e35', // text-secondary base-black-black-600 1f2e35 ec5540
          900: '#0e1518',
          950: '#0e1518e6',
        },
        primary: {
          color: '{primary.500}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.700}',
          contrastColor: '#ffffff',
        },
        text: {
          color: '{surface.800}',
          hoverColor: '{surface.900}',
          mutedColor: '{surface.600}',
          hoverMutedColor: '#35454c',
        },
        content: {
          background: '#ffffff',
          hoverBackground: '#fcfcfc',
          borderColor: '{surface.200}',
          color: '{surface.800}',
        },
        formField: {
          background: '#ffffff',
          disabledBackground: '#e9ebeb', // fill-disabled base-black-black-50
          filledBackground: '#f6f8f9',
          filledHoverBackground: '#eff2f3',
          filledFocusBackground: '#ffffff',
          borderColor: '{surface.200}',
          hoverBorderColor: '{primary.500}',
          focusBorderColor: '{primary.500}',
          invalidBorderColor: '#d74d3a',
          color: '{surface.800}',
          disabledColor: '{surface.300}',
          placeholderColor: '{surface.500}',
          floatLabelColor: '{surface.500}',
          floatLabelFocusColor: '{primary.500}',
          floatLabelActiveColor: '{surface.600}',
          floatLabelInvalidColor: '#d74d3a',
          iconColor: '{surface.500}',
        },
        navigation: {
          item: {
            color: '{surface.500}',
            activeColor: '{surface.800}',
            focusColor: '{surface.800}',
          },
        },
      },
    },

    typography: {
      fontFamily:
        "'Roboto', 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
      headingFontFamily:
        "'Nunito', 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
      monoFontFamily:
        "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    },
  },

  components: {
    inputgroup: {
      colorScheme: {
        light: { addon: { background: '#f3f4f6' } },
      },
    },

    dialog: { root: { borderRadius: '6px' } },
    button: {
      colorScheme: {
        light: {
          root: {
            borderRadius: '4px',
            secondary: {
              color: '{surface.800}',
              activeColor: '{surface.800}',
              hoverColor: '{surface.800}',
              background: '{primary.50}',
              activeBackground: '{primary.100}',
              hoverBackground: '{primary.100}',
            },
            success: {
              background: '{mgreen.500}',
              activeBackground: '{mgreen.700}',
              hoverBackground: '{mgreen.700}',
              borderColor: '{mgreen.500}',
              activeBorderColor: '{mgreen.700}',
              hoverBorderColor: '{mgreen.700}',
            },
            danger: {
              color: '{surface.800}',
              activeColor: '{surface.800}',
              hoverColor: '{surface.800}',
              background: '{mred.50}',
              activeBackground: '{mred.100}',
              hoverBackground: '{mred.100}',
              borderColor: '{mred.300}',
              activeBorderColor: '{mred.300}',
              hoverBorderColor: '{mred.300}',
            },
          },
          outlined: {
            contrast: {
              borderColor: '{surface.200}',
              color: '{surface.800}',
            },
          },
        },
      },
    },

    splitbutton: {
      root: { borderRadius: '6px' },
    },

    tag: {
      colorScheme: {
        light: { warn: { background: '#ffe3b0' } },
      },
    },

    select: {
      root: { borderRadius: '4px' },
      overlay: { borderRadius: '4px' },
      option: { borderRadius: '4px' },
    },

    multiselect: {
      root: { borderRadius: '4px' },
      overlay: { borderRadius: '4px' },
      option: { borderRadius: '4px' },
    },

    datepicker: {
      date: {
        hoverBackground: '#eff2f3',
      },
    },
    toggleswitch: {
      handle: {
        size: '18px',
      },
    },
    toast: {
      icon: { size: '2.25rem' },
    },
  },
});
